module.exports = __webpack_public_path__ + "img/65.599e9b7c.jpg";